import { type ErrorResponse } from "@apollo/client/link/error";
import { compact } from "lodash";

export const allApolloErrorsToString = (error: ErrorResponse): string =>
  compact(error.graphQLErrors)
    .map((error) => error.message)
    .join("\n");
